import type { ClientNameMap } from 'types/client-systems';
import type { ExceptionStatus } from 'types/exceptions';

import { DefaultErpId, SelectOption } from './../types/index';

const PO_LINE_STATUSES: ExceptionStatus[] = ['New', 'In Progress', 'Resolved'];
export const PO_LINE_STATUS_SELECT_OPTIONS: SelectOption[] = PO_LINE_STATUSES.map((status) => ({
  name: status,
  value: status,
}));

/** === TIME === */
const MS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;
export const ONE_MINUTE = SECONDS_PER_MINUTE * MS_PER_SECOND;
export const ONE_HOUR = ONE_MINUTE * MINUTES_PER_HOUR;

export const SPOOFED_LS_KEY = 'spoofed-client-id';

export const CLIENT_NAMES: ClientNameMap = {
  clarium: 'Clarium Health',
  bch: `Boston Children's Hospital`,
  ghs: 'Geisinger',
  ynhh: 'Yale New Haven Hospital',
  csh: 'CommonSpirit Health',
  uwni: 'University of Wisconsin (UWNI)',
  mdanderson: 'M.D. Anderson Cancer Center',
  slbnc: "St. Luke's Boise Medical Center",
};

export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE_SIZE_AS_STRING = '25';
export const DEFAULT_ERP_ID: DefaultErpId = '00000000-0000-0000-0000-000000000000';
export const INTERCOM_APP_ID = 'munyvxc4';
